import './ScrollableRegion-c1018dbe.css';

var classes = {"ScrollableRegion":"prc-ScrollableRegion-ScrollableRegion-3VVm3"};

export { classes as default };
